'use strict';
import {ACTIVE_TIMERS_LIST_NAME, ASSET_TASK_LOG_NAME, PROJECT_TASK_LOG_NAME, TIMER_EXPORT_NAME} from '../redux/state';

/**
 *
 * CODE_TAG[Global-state-shape-aware]
 * @param rootState
 * @return {*}
 */
export function getState(rootState) {
  return rootState.timers;
}

export function getActiveTimers(rootState) {
  return getState(rootState)[ACTIVE_TIMERS_LIST_NAME];
}

export function getActiveTimersSafe(rootState) {
  const state = getState(rootState || {});
  return state ? state[ACTIVE_TIMERS_LIST_NAME] : void 0;
}

export function getAssetTaskLog(rootState) {
  return getState(rootState)[ASSET_TASK_LOG_NAME];
}

export function getProjectTaskLog(rootState) {
  return getState(rootState)[PROJECT_TASK_LOG_NAME];
}

/**
 * @param {*} rootState
 * @returns {TimerExportState}
 */
export function getTimerExport(rootState) {
  return getState(rootState)[TIMER_EXPORT_NAME];
}



// WEBPACK FOOTER //
// ./src/js/timers/reducers/state.js